import { CategoryNavAccordionItem } from '@/features/shop/components/UngatedCategoryPage/CategoryNavAccordionItem'
import { getUniversalCategories } from '@/features/shop/services/UniversalCategories/utils'
import { useCurrentUniversalCategory } from '@/features/shop/services/UniversalCategories/hooks'
import { AccordionGroup } from '@shipt/design-system-accordion'
export const CategoryNavAccordion = () => {
  const categories = getUniversalCategories()
  const currentCategory = useCurrentUniversalCategory()

  return (
    <AccordionGroup hasLeadingBorder={false}>
      {categories.map((category) => (
        <CategoryNavAccordionItem
          category={category}
          currentCategory={currentCategory}
          // include currentCategory in key to create a new component
          // instead of rerendering the old one
          key={`${currentCategory?.id || ''}${category.id}`}
        />
      ))}
    </AccordionGroup>
  )
}
